import { render, staticRenderFns } from "./author-list-item.vue?vue&type=template&id=79c774c3&scoped=true&"
import script from "./author-list-item.vue?vue&type=script&lang=js&"
export * from "./author-list-item.vue?vue&type=script&lang=js&"
import style0 from "./author-list-item.vue?vue&type=style&index=0&id=79c774c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c774c3",
  null
  
)

export default component.exports